// Store
import store from "@/store.js";
import { HasQuotingService } from "@helpers/albumContractAdapter";

export default {
    methods: {
        /**
         * Builds the price request for a pre-calculated album group.
         * The group size comes from the active Promotions JSON
         * (albumPromotion.transaction.maxAlbumsPerBatch) through PhotoParkHelper.quoteParks.
         */
        BuildChunkRequest: async function (el, baseItem) {
            const cantidad = Number(baseItem?.ServiceNumber || el.length);
            const requestItem = {
                ...baseItem,
                cantidad,
                ServiceNumber: cantidad,
                Parks: el,
            };
            const price = await store.dispatch("GetNewPrice", requestItem);
            const parks = el.map((p) => p.Park.Id);

            // Builds the sivexData object using the chunk for availableParks.
            const sivexData = {
                packageId: price.packageId,
                ServiceId: price.ServiceId,
                ServiceNumber: cantidad,
                itineraryId: price.itineraryId,
                options: price.options,
                Amount: price.Amount,
                availableParks: parks,
                Promotions: price.Promotions,
            };

            return { price, sivexData };
        },
        /**
         * Processes the parks in an album.
         * @param {Object} park - The park object to process.
         * @param {number} idx - The album index in the state.
         * @return {void}
         */
        processParks: async function (park, idx) {
            store.state.albumes[idx].park.map(function (data) {
                if (
                    data.Park.IsHotel &&
                    data.IsAdded &&
                    !HasQuotingService(data.QuotingService)
                ) {
                    data.IsAdded = false;
                    store.state.shoppingCart[park.Reservation.BookId]
                        .cantidad--;
                }
            });
        },
        /**
         * Gets only the parks in an album.
         * @param {number} idx - The album index in the state.
         * @return {Array} - An array of parks that are not hotels and are added to the album.
         */
        getOnlyAlbumsParks: function (idx) {
            return store.state.albumes[idx].park.filter(
                (data) =>
                    data.IsAdded &&
                    !data.Park.IsHotel &&
                    !HasQuotingService(data.QuotingService)
            );
        },
    },
};
